var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraduate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5190",
    "data-name": "Group 5190",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135.214,
    height: 150,
    viewBox: "0 0 135.214 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1182",
    "data-name": "Rectangle 1182",
    width: 135.214,
    height: 150,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5189",
    "data-name": "Group 5189",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5188",
    "data-name": "Group 5188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5187",
    "data-name": "Group 5187",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5186",
    "data-name": "Group 5186",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5185",
    "data-name": "Group 5185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5184",
    "data-name": "Group 5184",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4173",
    "data-name": "Path 4173",
    d: "M105.869,40.292c13.809,17.013,28.17,30.38,29.275,44.962,1.1,14.472-11.047,30.159-24.967,42.532-13.809,12.483-29.5,21.763-45.4,22.2-16.018.332-32.257-8.285-44.188-20.768A74.8,74.8,0,0,1,.148,82.934C-.957,65.48,4.124,46.81,15.945,29.908,27.765,12.9,46.435-2.35,62.454.3c16.128,2.541,29.5,23.089,43.415,39.991",
    fill: "#0af"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4174",
    "data-name": "Path 4174",
    d: "M94.531,72a1.755,1.755,0,0,0-1.646-.162L69.022,82.391,44.049,71.144a1.717,1.717,0,0,0-1.586.122,1.758,1.758,0,0,0-.833,1.36L38.778,101.74a1.805,1.805,0,0,0,.781,1.705,1.708,1.708,0,0,0,1.925-.03c5.2-3.693,11.856-7.677,13.525-7.677,1.352,0,6.841,4.326,11.754,9.27a1.709,1.709,0,0,0,2.3.1c4.091-3.436,10.99-8.266,13.547-8.266,3.013,0,9.081,4.783,10.988,6.477a1.748,1.748,0,0,0,1.112.415,1.709,1.709,0,0,0,.811-.212,1.834,1.834,0,0,0,.925-1.667L95.3,73.414A1.768,1.768,0,0,0,94.532,72Z",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4175",
    "data-name": "Path 4175",
    d: "M114.725,52.246,69.076,35.1a1.691,1.691,0,0,0-1.179.007L20.513,52.246a1.775,1.775,0,0,0-1.174,1.617,1.817,1.817,0,0,0,1.037,1.713L30.4,60.54c-1.683,2.675-3.272,6.916-2.9,14.461h-.227c-1.518,0-2.776.635-2.776,2.243v4.708a2.914,2.914,0,0,0,2.132,2.857l-4.285,29.935,1.894-1.216c.233-.153.572-.338.888-.5.066.731.184,1.43.892,1.688a1.8,1.8,0,0,0,.641.122,2.627,2.627,0,0,0,1.858-1.043,3.689,3.689,0,0,1,.582-.516c.122.127.3.33.416.468A2.7,2.7,0,0,0,31.415,115l.395-.054a2.786,2.786,0,0,0,1.755-1.977,7.491,7.491,0,0,1,1.166.456l1.769.87L32.057,84.783a3.016,3.016,0,0,0,2.135-2.832V77.243c0-1.609-1.456-2.243-2.967-2.243h-.948l3.791-12.771,15.394,6.927,18.473,6.99a1.71,1.71,0,0,0,1.2-.046l21.1-8.789,24.675-11.757a1.827,1.827,0,0,0-.183-3.31Z",
    fill: "#2b528e"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduate);
export default __webpack_public_path__ + "static/media/graduate.6c3a63ba7d10f233d636f58bb48949d5.svg";
export { ForwardRef as ReactComponent };